import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import styles from "./cookieconsent.module.css"; // ✅ Import CSS module correctly

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!Cookies.get("essentialCookiesAccepted")) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    Cookies.set("essentialCookiesAccepted", "true", { expires: 1 });
    console.log("Cookie set:", Cookies.get("essentialCookiesAccepted"));
    setShowBanner(false);
  };

  return (
    showBanner && (
      <div className={styles.cookiebanner}>
        <p className={styles.cookietext}>
          This site uses only essential cookies to ensure the proper functioning
          of the website. No personal data is collected. By continuing to browse
          this site, you accept the use of these cookies.
        </p>
        <button className={styles.cookiebutton} onClick={handleAcceptCookies}>
          I accept
        </button>
      </div>
    )
  );
};

export default CookieConsent;
